import { onDomReady } from '../../components/dynamic/observer';

class CatalogFilter {
    constructor(selector) {
        this.nameProductContainer = selector; // контейнер
        this.nameProduct = selector.querySelector('[data-sticky-producer]');
        this.positionStickyElement = document.querySelector('[data-drop-stycky]');
        this.bottomMenuDropHeight = document.querySelector('[data-drop-sticky-bottom]');
        this.positionSticky = this.getDistanceFromTop(this.positionStickyElement); // Получаем статическое значение
        this.eventListeners();
    }

    // Метод для получения расстояния от верхней части документа до нижней элемента
    getDistanceFromTop(element) {
        const rect = element.getBoundingClientRect();
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        return rect.bottom + scrollTop;

    }

    addSticky() {
        const header = document.querySelector('[data-header]');
        const headerHeight = header.offsetHeight;
        const bottomMenuDropHeight = this.bottomMenuDropHeight.offset;
        this.lastScrollTop = document.documentElement.scrollTop; // Инициализация начальной позиции прокрутки

        window.addEventListener('scroll', () => {
            const currentScrollTop = document.documentElement.scrollTop; // Текущая позиция прокрутки

                if (window.scrollY >= this.positionSticky) {
                    this.nameProduct.classList.add("add-sticky");

                    if (currentScrollTop < this.lastScrollTop) {
                        this.nameProduct.style.top = `${headerHeight}px`;
                    }
                    if (currentScrollTop > this.lastScrollTop) {
                        this.nameProduct.style.top = 0;
                    }
                }

                if (window.scrollY <= this.positionSticky) {
                    this.nameProduct.classList.remove("add-sticky");
                    this.nameProduct.style.top = 0;
                }


            // Обновляем значение последней прокрутки
            this.lastScrollTop = currentScrollTop;
        });
    }

    eventListeners() {
        this.addSticky();
    }
}

onDomReady(() => {
    const catalogSlickSelector = document.querySelector('[data-drop-producer-container]');
    if (catalogSlickSelector) {
        new CatalogFilter(catalogSlickSelector);
    }
});
